<template>
  <div class="project-picture" :class="canvas && 'canvas-height'">
    <div class="img-wrapper">
      <slot name="pic"> </slot>
    </div>
    <div class="label">
      <slot name="label"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "projectPicture",
  props: {
      canvas: {
          type: Boolean,
          default: false
      }
  }
};
</script>

<style lang="scss">
.project-picture {


  border-radius: 20px;
  overflow: hidden;
  position: relative;

  .dark & {
    background-color: black;
  }
  .light & {
    background-color: #fff;
    background-image: linear-gradient(45deg, #f7f7f7, #fbf5ff);

    img {
      box-shadow: 1px 10px 20px #dad6e0, 1px 1px 1px rgba(223, 211, 234, 0.3);
    }
  }



  .img-wrapper {
    padding: 1rem;
    border-radius: 20px;

  }

  &.canvas-height {
      .img-wrapper {
        height: 600px;
      }

  }

  .label {
    padding-right: 1rem;
    padding-bottom: 1px;
    position: relative;

    p {
      font-size: 85%;
      font-style: oblique;
      text-align: right;
      margin-bottom: 0;
      margin: 0 0 1rem;
    }
  }
}
</style>
